import React, { useState, useEffect,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AxiosInstance from '../AxiosInstance';
import Layout from './Layout';
import ToastNotification from '../ToastNotification';
import { Button } from 'react-bootstrap';

const AdminProfile = () => {
  const userId = localStorage.getItem('employeeId');
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const imageUrl = process.env.REACT_APP_BASE_URL+'/uploads/';
  const toastRef=useRef();
  useEffect(() => {
    AxiosInstance
      .get(`/common/api/user-details/${userId}`)
      .then((response) => {
        const data = response.data;

        // Parse JSON safely for social_media_links
        if (typeof data.social_media_links === 'string') {
          try {
            data.social_media_links = JSON.parse(data.social_media_links);
          } catch (error) {
            toastRef.current?.showToast("Failed to load social media links.", "danger");
            data.social_media_links = [];
          }
        }

        setUserData(data);
      })
      .catch((error) => {
        const message = error.response?.data?.error || "Failed to fetch user data.";
        toastRef.current?.showToast(message, "danger");
      });
  }, [userId]);
  
  if (!userData) {
    return (
      <Layout heading="profile">
      <div>Loading...</div>
      </Layout>
    );
  }

 const {
  first_name,
  last_name,
  username,
  email,
  image_profile,
  about,
  social_media_links,
  phone_number,
  permanent_building_no,
  permanent_landmark,
  permanent_locality,
  permanent_city,
  permanent_state,
  permanent_country,
  permanent_pincode,
} = userData;

const toTitleCase = (str) =>
  str
    .toLowerCase()
    .split(',') // split by commas first
    .map(part =>
      part
        .trim()
        .split(' ') // split by spaces
        .map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
        )
        .join(' ')
    )
    .join(', ');

const rawAddressFields = [
  permanent_building_no,
  permanent_landmark,
  permanent_locality,
  permanent_city,
  permanent_state,
  permanent_country,
  permanent_pincode
];

const filteredAddress = rawAddressFields
  .filter(field => field && field !== 'Not provided' && field.trim() !== '')
  .join(', ');

const fullAddress = filteredAddress ? toTitleCase(filteredAddress) : null;

  return (
    <Layout heading="profile">
      <div className="d-flex justify-content-end mb-3">
      <Button
        variant="primary"
        className="btn-sm"
        onClick={() => navigate('/admin/edit-profile')}
      >
        <i className="bi bi-pencil me-2"></i>
      </Button>
    </div>
     <div className="container">
    <div className="row align-items-center p-4" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
      <div className="col-12 col-md-auto d-flex justify-content-center">
        <div 
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            overflow: 'hidden',
            backgroundColor: '#ccc',
          }}
        >
          <img
            src={image_profile ? `${imageUrl + image_profile}` : 'path/to/default.jpg'}
            alt="Profile"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
      </div>
      <div className="col-12 col-md ms-md-4 text-center text-md-start mt-3 mt-md-0">
        <h4 style={{ textTransform: 'capitalize' }}>{`${first_name} ${last_name}`}</h4>
        <p>User ID: {userId}</p>
        <p>Username: {username}</p>
      </div>
      
    </div>

      <div className="user-info" style={{ marginTop: '20px' }}>
      <h5>Email</h5>
        <p>{email ? email : 'No information provided'}</p>

        <h5>Phone Number</h5>
        <p>{phone_number ? phone_number : 'No phone number provided'}</p>


        <h5>About</h5>
        <p style={{ textAlign: 'justify' }}>{about ? about : 'No information provided'}</p>

       <h5>Location</h5>
        <p>{fullAddress ? fullAddress : 'No address provided'}</p>

        {/* <h5>Phone Number</h5>
        <p>{phone_number ? phone_number : 'No phone number provided'}</p> */}

        <h5>Website</h5>
          <div>
            {Array.isArray(social_media_links) && social_media_links.length > 0 ? (
              social_media_links.map((link, index) => (
                <p key={index}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.platform}
                  </a>
                </p>
              ))
            ) : (
              <p>No social media links provided</p>
            )}
          </div>
      </div>
    </div>
      <ToastNotification ref={toastRef} />
    </Layout>
  );
};

export default AdminProfile;
